import React, { Component } from 'react';
import { toast } from 'react-toastify';

import Spinner from 'components/Spinner';
import ExpireSubForm from './ExpireSubForm';
import getCarrier from 'helpers/getCarrier';
import expiryTypes from 'constants/expiryTypes';
import BaseModal from '../BaseModal';
import { sortSimoExpiryTypes } from 'helpers/subs';

import styles from './styles.module.scss';

class ExpireSubModal extends Component {
  state = {
    loading: false,
    expiryTypeOptions: null,
  };

  componentDidMount() {
    this.loadExpiryTypes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isOpen &&
      !this.state.expiryTypeOptions &&
      !this.state.loading
    ) {
      this.loadExpiryTypes();
    }
  }

  loadExpiryTypes = () => {
    const { fetchExpiryOptions, isOpen } = this.props;
    if (fetchExpiryOptions && isOpen) {
      this.setState({ loading: true });
      fetchExpiryOptions(this.props.subId)
        .then((res) => {
          const choices = res.data && res.data.actions.POST.expiry_type.choices;
          let expiryTypeOptions = choices.map(({ value, display_name }) => [
            value,
            display_name,
          ]);
          expiryTypeOptions = sortSimoExpiryTypes(expiryTypeOptions);
          this.setState({ expiryTypeOptions });
        })
        .catch((e) => {
          toast.error('Failed to load expiry choices');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  handleExpireSub = (values) => {
    const { sub, expireSub, findSub, closeModal } = this.props;

    this.setState({ loading: true });
    return expireSub(sub.id, values)
      .then(() => findSub(sub.id))
      .then(() => {
        closeModal();
        toast.success('Subscription Expired');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      sub,
      isOpen,
      closeModal,
      showBypass,
      showProration,
      showPin,
      isQuick,
    } = this.props;
    const { loading, expiryTypeOptions } = this.state;

    const types = expiryTypeOptions || expiryTypes;
    const initialValues = { expiry_type: types[0][0] };
    if (showPin) {
      initialValues.pin = sub && sub.pin;
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title="Expire Subscription"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <ExpireSubForm
          initialValues={initialValues}
          onSubmit={this.handleExpireSub}
          types={types}
          carrier={getCarrier(sub)}
          showBypass={showBypass}
          showProration={showProration}
          showPin={showPin}
          isQuick={isQuick}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default ExpireSubModal;
